import { render } from "./StatistiqueAchat.vue?vue&type=template&id=3a687e9c&scoped=true"
import script from "./StatistiqueAchat.vue?vue&type=script&lang=js"
export * from "./StatistiqueAchat.vue?vue&type=script&lang=js"

import "./StatistiqueAchat.vue?vue&type=style&index=0&id=3a687e9c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a687e9c"]])

export default __exports__